import { createSlice } from '@reduxjs/toolkit';
import { DIALOG_TYPE } from '../../define/global';
import { createSelectorFn } from './common';

const initialState = {
  isOpen: false,
  dialogType: DIALOG_TYPE.DIALOG_NONE,
  arg: {}
};

const dialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    openDialog: (state, action) => {
      state.isOpen = true;
      state.dialogType = action.payload.dialogType;

      if (action.payload.arg === undefined) state.arg = {};
      else state.arg = action.payload.arg;
    },
    closeDialog: () => initialState
  }
});

export const { openDialog, closeDialog } = dialogSlice.actions;
export const useDialogSliceSelector = createSelectorFn(dialogSlice);
export default dialogSlice;
